import { twMerge } from 'tailwind-merge';
import ListItem from '@mui/material/ListItem';
import { useFormField } from '@witmetrics/data-store';
import { useFormProvider } from '@/providers/FormProvider';
import FieldTypeIcon from '@/components/FieldTypeIcon';
import { LABELS } from './constants';
import { classes, styles } from './utils';

export type FieldsListItemProps = {
  fieldId: number;
};

export default function FieldsListItem({ fieldId }: FieldsListItemProps) {
  const field = useFormField(fieldId);
  const { activeFieldId, onSelectField } = useFormProvider();

  if (!field) return null; // TODO

  return (
    <ListItem
      dense
      disableGutters
      sx={styles.listItem}
      className={twMerge(
        classes.listItem,
        activeFieldId === fieldId && classes.active
      )}
      onClick={() => onSelectField(fieldId)}>
      <div className={classes.wrapper}>
        <FieldTypeIcon fieldTypeId={field.formFieldTypeId} />
        <div className={classes.content}>
          <div className={classes.fieldType}>
            {LABELS[field.formFieldTypeId]}
          </div>
          <div className={classes.fieldLabel}>{field.label}</div>
        </div>
      </div>
    </ListItem>
  );
}
